import classNames from 'classnames'
import { useHistory } from 'react-router'

import { isMobile } from 'shared/responsive-helpers'

import Textfield from 'shared/components/Textfield'
import Button from 'shared/components/Button'

import { startReservationExtension } from 'extending/actions'
import { setReservations } from 'dashboard-transactions/actions'
import { getReservationsByParam, clearReservationsByParamErrorState, clearGuestReservationsState } from '../actions'
import { clearEntity } from 'entities/actions'

import { reservationsSelector } from 'extending/selectors'
import { confirmedReservationIdSelector, confirmedReservationEmailAddressSelector } from 'confirmation/selectors'
import { getReservationsByParamErrorSelector, getGuestUserReservationsPendingSelector } from '../selectors'

import styles from '../styles.module.scss'

const FindBooking = ({
    getReservationsError,
    getReservationsByParam,
    clearReservationsByParamErrorState,
    clearGuestReservationsState,
    isBtnStatePending,
    reservations,
    startReservationExtension,
    setReservations,
    confirmationNumber,
    orderEmailAddress,
    clearEntity,
}) => {
    const history = useHistory()
    const [bookingData, setBookingData] = React.useState({
        email: orderEmailAddress,
        referenceNumber: confirmationNumber,
    })

    const isButtonEnabled =
        (bookingData?.email && bookingData?.referenceNumber) || (confirmationNumber && orderEmailAddress)

    const getReservationsHandler = () => {
        clearReservationsByParamErrorState()
        getReservationsByParam(bookingData.referenceNumber, bookingData.email)
    }

    React.useEffect(() => {
        //every time page is rendered all guest reservations and entities reservations state should be reset
        clearGuestReservationsState(), clearEntity('reservations')
    }, [])

    React.useEffect(() => {
        if (Object.keys(reservations).length > 0) {
            startReservationExtension(Object.keys(reservations)[0])
        }
    }, [reservations])

    return (
        <section className={styles.findBookingContainer}>
            <p className={styles.textDescription}>
                <T>manage.my.booking.description.part1</T>
            </p>
            <p className={styles.textDescription}>
                <T>manage.my.booking.description.part2</T>
            </p>
            <div className={classNames('d-flex flex-column flex-md-row', styles.manageBookingForm)}>
                <Textfield
                    name="email"
                    type="email"
                    value={bookingData?.email || orderEmailAddress}
                    required
                    onChange={e => setBookingData({ ...bookingData, email: e.currentTarget.value })}
                    label={<T>manage.my.booking.email.placeholder</T>}
                    className={styles.emailInput}
                />
                <Textfield
                    name="outboundNumber"
                    value={bookingData?.referenceNumber || confirmationNumber}
                    required
                    onChange={e => setBookingData({ ...bookingData, referenceNumber: e.currentTarget.value })}
                    label={<T>manage.my.booking.reference.number.placeholder</T>}
                    minLength={1}
                />
            </div>
            <Button
                size={isMobile() ? 'small' : 'large'}
                block={isMobile()}
                onClick={getReservationsHandler}
                className="mt-6 brand-button "
                disabled={!isButtonEnabled}
                btnStyle="primary"
                isLoading={isBtnStatePending}>
                <T>manage.my.booking.continue.button.label</T>
            </Button>
            {getReservationsError && (
                <div className="mt-2 error-text">{<T>manage.my.booking.get.reservations.error.msg</T>}</div>
            )}
        </section>
    )
}

export default compose(
    connect(
        createStructuredSelector({
            getReservationsError: getReservationsByParamErrorSelector,
            isBtnStatePending: getGuestUserReservationsPendingSelector,
            reservations: reservationsSelector,
            confirmationNumber: confirmedReservationIdSelector,
            orderEmailAddress: confirmedReservationEmailAddressSelector,
        }),
        {
            getReservationsByParam,
            clearReservationsByParamErrorState,
            clearGuestReservationsState,
            startReservationExtension,
            setReservations,
            clearEntity,
        }
    )
)(FindBooking)
